exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3uyMj{background-color:#e4002b;cursor:pointer;font-family:roboto\\, Medium}.eR4TR{text-align:center;margin-top:70px}.eR4TR i{color:#e4002b}.c86Hq{height:250px}._3yxMF,.c86Hq{margin-bottom:20px}._3yxMF{height:120px}._3mm8I{min-height:69px}._3mm8I span{color:#e4002b}._3mm8I input[type=image]{cursor:pointer}._2W2FC{border-bottom:0}._32Ysn{color:#e4002b;background-color:transparent;border:none;width:100%;max-width:120px;font-size:16px}._32Ysn:hover{cursor:pointer}._3mm8I>:not(:last-child){margin-right:0}._3mm8I>:not(:first-child){margin-left:0}", ""]);

// exports
exports.locals = {
	"boton_rojo": "_3uyMj",
	"modalContent": "eR4TR",
	"modalBody": "c86Hq",
	"imageContainer": "_3yxMF",
	"modalFooter": "_3mm8I",
	"modalHeader": "_2W2FC",
	"boton_accion": "_32Ysn"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/Telemedicina/ModalBienvenida/ModalBienvenida.css
// module id = 1300
// module chunks = 0 1